import { InputSummary, InputSummaryItem } from '../../../input-summary';
import InputSummaryUtils from '../../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';
import AnessaListItemUtil, { AnessaListItem } from '../../../anessa-list-item.interface';


export interface LoanInterface {
  name: string;
  uuid: string;
  loanType: string;
  loanAmount: UnitValue;
  interestRate: UnitValue;
  amortizationPeriod: UnitValue;
}

export class Loan implements AnessaListItem {
  name: string;
  uuid: string;
  loanType: string;
  loanAmount: UnitValue;
  interestRate: UnitValue;
  amortizationPeriod: UnitValue;

  constructor(param: LoanInterface = {
    name: '',
    uuid: null,
    loanType: '',
    loanAmount: new UnitValue(),
    interestRate: new UnitValue(),
    amortizationPeriod: new UnitValue()
  }) {
    this.name = param.name;
    this.uuid = param.uuid ? param.uuid : uuid();
    this.loanType = param.loanType;
    this.loanAmount = new UnitValue(param.loanAmount);
    this.interestRate = new UnitValue(param.interestRate);
    this.amortizationPeriod = new UnitValue(param.amortizationPeriod);
    this.amortizationPeriod.unit = '000000000000000000001305';
  }

  static deepCopy(l: Loan) {
    let copy;
    if (l) {
      copy = new Loan(l);
      return copy;
    }
    throw new Error('Loan copy failed');
  }

  getInputSummary(path: string[]) {
    const inputSummary = new InputSummary();
    inputSummary.inputs = this.getSummaryInputs(path);
    return inputSummary;
  }

  getSummaryInputs(path: string[]) {
    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, LoanPropName.loanType, this.loanType, [...path, 'loanType']);
    inputs = InputSummaryUtils.performPush(inputs, LoanPropName.loanAmount, this.loanAmount, [...path, 'loanAmount']);
    inputs = InputSummaryUtils.performPush(inputs, LoanPropName.interestRate, this.interestRate, [...path, 'interestRate']);
    inputs = InputSummaryUtils.performPush(inputs, LoanPropName.amortizationPeriod, this.amortizationPeriod, [...path, 'amortizationPeriod']);
    return inputs;
  }

  getUuidForPath() {
    return AnessaListItemUtil.getUuidForPath(this.uuid);
  }

  isForgiven() {
    return this.loanType === LoanType.Forgiven;
  }
}

export enum LoanPropName {
  name = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.LOAN.NAME',
  loanType = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.LOAN.LOAN_TYPE',
  loanAmount = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.LOAN.LOAN_AMOUNT',
  interestRate = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.LOAN.INTEREST_RATE',
  amortizationPeriod = 'INPUT_SUMMARY.FINANCIAL.INVESTMENT.LOAN.AMORTIZATION_PERIOD',
  id_name = 'loan name',
  id_loanType = 'loan type',
  id_loanAmount = 'loan amount',
  id_interestRate = 'interest rate',
  id_amortizationPeriod = 'amortization period'
}

export enum LoanType {
  Annuity = 'PROJECT.FINANCIAL_INVESTMENT.ANNUITY',
  Serial = 'PROJECT.FINANCIAL_INVESTMENT.SERIAL',
  Forgiven = 'PROJECT.FINANCIAL_INVESTMENT.FORGIVEN'
}
